import { render } from "./DialogResolveContact.vue?vue&type=template&id=5362623a&scoped=true"
import script from "./DialogResolveContact.vue?vue&type=script&lang=js"
export * from "./DialogResolveContact.vue?vue&type=script&lang=js"

import "./DialogResolveContact.vue?vue&type=style&index=0&id=5362623a&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5362623a"]])

export default __exports__